interface IOptions {
  deviation?: number;
}

const detectElementBottom = (event, callback: () => void, options?: IOptions) => {
  const target = event.target;
  const { deviation = 1 } = options || {};

  const deviationNegative = -deviation;
  const deviationPositive = deviation;

  const isBottom =
    target.scrollHeight - target.scrollTop > target.clientHeight + deviationNegative &&
    target.scrollHeight - target.scrollTop < target.clientHeight + deviationPositive;

  if (isBottom) {
    callback();
  }
};

export default detectElementBottom;
